/**
 * TanStack Query hooks for `payout-record-pull`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	payoutRecordPullQueryKeys,
	type CreatePayoutRecordPullBody,
	type ListPayoutRecordPullResponse,
	type PayoutRecordPullRow,
} from "./api";

export function usePayoutRecordPullList(): UseQueryResult<ListPayoutRecordPullResponse, Error> {
	return useQuery({
		queryKey: payoutRecordPullQueryKeys.list(),
		queryFn: list,
	});
}

export function usePayoutRecordPullCreate(): UseMutationResult<PayoutRecordPullRow, Error, CreatePayoutRecordPullBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: payoutRecordPullQueryKeys.all });
		},
	});
}

export function usePayoutRecordPullDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: payoutRecordPullQueryKeys.all });
		},
	});
}
